<template>
  <transition name="slide-fade">
    <div class="page page-your-kits">
      <div class="container">
        <header class="row">
          <h1 class="col-md-8">Questionnaires</h1>

          <div class>
            <div class="col-12">
              <div class="page-description">
                These questionnaires are an important part of the research projects that you are participating in. This valuable information contributes to advancing scientific discoveries relating to the microbiome.
                <br />Please complete all available questionnaires and ensure that you complete the Day of Sampling questionnaire on the day you take your sample.
              </div>
            </div>
          </div>
        </header>

        <template v-if="isLoading">
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading questionnaires
        </template>
        <template v-else>
          <template v-if="kits" v-for="project in kits">
            <div class="row" v-if="hasSurveyKits(project).length > 0" :key="project.id">
              <div class="col-12">
                <div class="projectTitle clearfix">
                  <div class="pull-left">
                    <div class="title">{{ project.name }}</div>
                    <div class="detail">{{ project.contactName }}</div>
                    <div class="detail">Phone: {{ project.phone }}</div>
                    <div class="detail">Email: {{ project.email }}</div>
                  </div>
                </div>
              </div>
            </div>

            <ul class="list-group">
              <SurveyItem
                v-for="kit in hasSurveyKits(project)"
                :key="kit.id"
                :kit="kit"
                :showCoach="false"
                @onClickAppointment="showBookingModal = true"
              />
            </ul>
          </template>

          <div
            v-if="kits.length == 0"
            class="alert alert-info col-md-12"
          >Questionnaires will appear when you activate your kit.</div>
        </template>
      </div>
      <ModalBooking :show="showBookingModal" @close="showBookingModal = false" />
    </div>
  </transition>
</template>

<script>
import SurveyItem from '@/components/elements/SurveyItem'
import ModalBooking from '@/components/models/ModalBooking'
export default {
  name: 'surveys',
  components: {
    SurveyItem,
    ModalBooking
  },
  data: function () {
    return {
      showBookingModal: false,
      isLoading: false
    }
  },
  mounted: function () {
    let self = this
    self.isLoading = true
    this.$store.dispatch('getUser')
    this.$store.dispatch('getResearchKits').then(
      response => {
        self.isLoading = false
      },
      error => {
        console.log(error)
      }
    )
  },
  computed: {
    kits: function () {
      return this.$store.state.GET_KITS_RESPONSE || []
    }
  },
  methods: {
    hasSurveyKits (project) {
      if (
        project.exerciseSurveyEnabled ||
        project.foodSurveyEnabled ||
        project.medicalSurveyEnabled ||
        project.mentalSurveyEnabled ||
        project.samplingSurveyEnabled ||
        project.infantDemographicAndMilkFeedingEnabled ||
        project.infantDayOfSamplingEnabled ||
        project.infantMedicalHistoryEnabled
      ) {
        return project.kits.filter(
          kit => kit.kitStatus !== 'UNASSIGNED' && kit.kitStatus !== 'ASSIGNED'
        )
      }
      return false
    }
  }
}
</script>

<style scoped>
.list-group {
  list-style: none;
  padding-left: 0;
}

.page-description {
  color: #00193d;
  font-size: 1rem;
}

.projectTitle {
  background: #41587a;
  color: #fefffb;
  padding: 20px;
  border-radius: 5px;
  margin: 10px 0;
}
.projectTitle .title {
  font-size: 20px;
  font-weight: 400;
}
.projectTitle .detail {
  fonts-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/application/research/Surveys.vue